module.exports = __webpack_public_path__ + "images/柏纳s长图_07.jpg?v=7bdc1f8a";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan2/柏纳s长图_07.jpg
 ** module id = 166
 ** module chunks = 1 2
 **/